import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLogged: false,
    user: null,
    isEditable:true
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth:{
            reducer(state, action) {
                state.isLogged = true;
                state.user = action.payload;
            }
        },
        removeAuth: {
            reducer(state) {
                state.isLogged = initialState.isLogged;
                state.user = initialState.user;
            }
            
        },
        setEdit: {
            reducer(state,action) {
                state.isEditable = action.payload;
            }
        }
    }
})

export const { setAuth, removeAuth ,setEdit} = authSlice.actions;

export default authSlice.reducer;